"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BPAMOJob__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "NotKeeper",
        type: "error",
    },
    {
        inputs: [],
        name: "ZeroAddress",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "curvePool",
                type: "address",
            },
            {
                internalType: "contract ICurveBPAMO",
                name: "amo",
                type: "address",
            },
            {
                internalType: "address",
                name: "agToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "indexAgToken",
                type: "uint256",
            },
        ],
        name: "_currentState",
        outputs: [
            {
                internalType: "bool",
                name: "addLiquidity",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "delta",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ICurveBPAMO",
                name: "amo",
                type: "address",
            },
        ],
        name: "adjust",
        outputs: [
            {
                internalType: "bool",
                name: "addLiquidity",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "delta",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "amoMinter",
        outputs: [
            {
                internalType: "contract IAMOMinter",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ICurveBPAMO",
                name: "amo",
                type: "address",
            },
        ],
        name: "currentState",
        outputs: [
            {
                internalType: "bool",
                name: "addLiquidity",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "delta",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimalNormalizer",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "amoMinter_",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class BPAMOJob__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.BPAMOJob__factory = BPAMOJob__factory;
BPAMOJob__factory.abi = _abi;
//# sourceMappingURL=BPAMOJob__factory.js.map